// extracted by mini-css-extract-plugin
export default {"StoreOrderSummary":"store-order-summary__StoreOrderSummary__B9GKu"};